import { View } from './view.js'

export const initData = async (view: View) => {
    // Execute in parallel
    await Promise.all([])
}
